var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSong = function SvgSong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M23.145.52a2.476 2.476 0 0 1 2.46 2.46v15c0 1.407-1.113 2.52-2.46 2.52h-15a2.5 2.5 0 0 1-2.52-2.52v-15c0-1.347 1.113-2.46 2.52-2.46zm0 17.46v-15h-15v15zm-9.375-1.23c-1.758 0-3.165-1.406-3.165-3.105a3.15 3.15 0 0 1 3.165-3.165c.703 0 1.347.235 1.875.645V4.27h4.98v2.46h-3.75v6.915c0 1.699-1.406 3.105-3.105 3.105M3.105 5.5v17.52h17.52v2.46H3.105a2.476 2.476 0 0 1-2.46-2.46V5.5z"
  })));
};
export default SvgSong;